module.exports = __webpack_public_path__ + "815e468caa22ffb6f124ad4cf9964b46.png";